import type { ReactElement } from 'react';
import { MicIcon } from './icons.js';
import type { VoiceComposerLabels } from './labels.js';
import { ScrollingWave, fmtTime } from './TakeWaves.js';

/**
 * Contenido de la barra mientras se graba un turno push-to-talk SOSTENIDO:
 * dot + tiempo + waveform deslizante (historial real del take) + hint de
 * deslizar, o el aviso de cancelar cuando el arrastre armó el descarte. La
 * grabación FIJADA no pasa por acá — el composer renderiza su propio panel
 * de dos filas (tiempo+onda arriba, tacho/pausa/enviar abajo, como WhatsApp).
 */
export function RecIndicator({
  elapsed,
  getSamples,
  cancelArmed,
  labels,
}: {
  elapsed: number;
  getSamples: () => readonly number[];
  cancelArmed: boolean;
  labels: Pick<VoiceComposerLabels, 'releaseToCancel' | 'slide'>;
}): ReactElement {
  // Cancelar armado: el mic + tiempo QUEDAN a la izquierda (el mic es el
  // protagonista de la animación de descarte al soltar — no puede esfumarse
  // antes); sólo la leyenda reemplaza a la onda, centrada en el espacio libre.
  if (cancelArmed) {
    return (
      <>
        <span className="ptt-recmic" aria-hidden>
          <MicIcon width={17} height={17} />
        </span>
        <span className="ptt-time">{fmtTime(elapsed)}</span>
        <span className="ptt-cancel-label">{labels.releaseToCancel}</span>
      </>
    );
  }
  return (
    <>
      {/* Mic rojo parpadeante (como WhatsApp) — protagonista de la animación
          de cancelar: el CancelSplash lo "lanza" al tacho desde este lugar. */}
      <span className="ptt-recmic" aria-hidden>
        <MicIcon width={17} height={17} />
      </span>
      <span className="ptt-time">{fmtTime(elapsed)}</span>
      <ScrollingWave getSamples={getSamples} />
      <span className="ptt-hint">{labels.slide}</span>
    </>
  );
}
